var _defs, _g, _text, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPublicIndoorpark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f1f5ff;stroke-width:1.5px;}.a,.c{stroke:#353841;}.b{fill:#353841;font-size:30px;font-family:Nunito-Bold, Nunito;font-weight:700;}.c,.e{fill:none;}.c{stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.d{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 74,
    height: 74,
    rx: 12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 0.75,
    y: 0.75,
    width: 72.5,
    height: 72.5,
    rx: 11.25
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "b",
    transform: "translate(27 50)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "P"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M6381,9219.3l7.276-6.11,7.277,6.11",
    transform: "translate(-6351.5 -9197.366)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublicIndoorpark);
export default __webpack_public_path__ + "static/media/public_indoorpark.4bdf4b1248977f479f0edd95bfed6933.svg";
export { ForwardRef as ReactComponent };